/**
 * Minimal PLP - v6
 * Numbered badges + Secure Your Box bar
 */
(function() {

  var addedOrder = [];
  var TIERS = [
    { items: 1, discount: 5 },
    { items: 2, discount: 7 },
    { items: 3, discount: 10 }
  ];

  function getDiscount(n) {
    if (n >= 3) return 10;
    if (n >= 2) return 7;
    if (n >= 1) return 5;
    return 0;
  }

  function getNextTier(n) {
    if (n === 0) return { needed: 1, discount: 5 };
    if (n === 1) return { needed: 1, discount: 7 };
    if (n === 2) return { needed: 1, discount: 10 };
    return null;
  }

  /* INIT */
  fetchCartAndUpdate();

  /* ATC HANDLER */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.card__size-btn');
    if (!btn || btn.disabled) return;
    // Don't handle lightbox clicks — lightbox.js handles those
    if (e.target.closest('#product-lightbox')) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    var productId = btn.getAttribute('data-product-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.textContent = '...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('fail');
      return r.json();
    })
    .then(function() {
      btn.textContent = '\u2713';

      if (productId && addedOrder.indexOf(productId) === -1) {
        addedOrder.push(productId);
      }
      showBadge(productId);

      return fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateBar(cart.item_count);
      pulseBtn();
      if (typeof window.startHoldTimer === 'function') window.startHoldTimer();
      

      setTimeout(function() {
        btn.textContent = originalText;
      }, 1200);
    })
    .catch(function() {
      btn.textContent = '!';
      setTimeout(function() { btn.textContent = originalText; }, 1500);
    });
  });

  /* BADGE */
  function showBadge(productId) {
    if (!productId) return;
    var badge = document.querySelector('[data-product-badge="' + productId + '"]');
    if (!badge) return;
    var num = addedOrder.indexOf(productId) + 1;
    badge.textContent = num;
    badge.style.display = 'flex';
  }

  /* PULSE the secure button */
  function pulseBtn() {
    var btn = document.getElementById('secureBtn');
    if (!btn) return;
    btn.classList.remove('pulse');
    void btn.offsetHeight;
    btn.classList.add('pulse');
    setTimeout(function() { btn.classList.remove('pulse'); }, 700);
  }

  /* UPDATE BAR — tiers, nudge, title, badge */
  function updateBar(count) {
    var discount = getDiscount(count);
    var next = getNextTier(count);

    // Tier dots
    for (var i = 1; i <= 3; i++) {
      var dot = document.getElementById('dot' + i);
      var lbl = document.getElementById('label' + i);
      var tier = document.getElementById('tier' + i);
      if (!dot || !lbl || !tier) continue;

      var active = count >= i;
      var current = getDiscount(count) === TIERS[i - 1].discount && count > 0;

      dot.className = 'tier-dot' + (active ? ' lit' : '');
      lbl.className = 'tier-label' + (active ? ' lit' : '');
      tier.className = 'tier-item' + (current ? ' active' : '');
    }

    // Nudge pill
    var pill = document.getElementById('nudgePill');
    var nudgeText = document.getElementById('nudgeText');
    if (pill && nudgeText) {
      // Force re-animation
      pill.style.animation = 'none';
      void pill.offsetHeight;
      pill.style.animation = '';

      if (count === 0) {
        pill.className = 'nudge-pill empty';
        nudgeText.className = 'nudge-text dim';
        nudgeText.textContent = 'ADD AN ITEM TO START SAVING';
      } else if (next) {
        pill.className = 'nudge-pill glow';
        nudgeText.className = 'nudge-text green';
        nudgeText.textContent = '\u26A1 ADD ' + next.needed + ' MORE FOR ' + next.discount + '% OFF';
      } else {
        pill.className = 'nudge-pill glow';
        nudgeText.className = 'nudge-text green';
        nudgeText.textContent = '\u2726 MAX DISCOUNT UNLOCKED \u2014 10% OFF';
      }
    }

    // Button title shimmer
    var title = document.getElementById('btnTitle');
    if (title) {
      title.className = count > 0 ? 'btn-title shimmer' : 'btn-title';
    }

    // Button subtitle
    var sub = document.getElementById('btnSubtitle');
    if (sub) {
      if (count > 0) {
        sub.style.display = 'block';
        sub.textContent = count + ' item' + (count !== 1 ? 's' : '') + ' \u00B7 saving ' + discount + '%';
      } else {
        sub.style.display = 'none';
      }
    }

    // Cart badge
    var badge = document.getElementById('barCartBadge');
    if (badge) {
      if (count > 0) {
        badge.style.display = 'flex';
        badge.textContent = count;
      } else {
        badge.style.display = 'none';
      }
    }
  }

  /* HELPERS */
  function fetchCartAndUpdate() {
    fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateBar(cart.item_count);

      if (cart.items && cart.items.length > 0) {
        var seen = [];
        cart.items.forEach(function(item) {
          var pid = String(item.product_id);
          if (seen.indexOf(pid) === -1) {
            seen.push(pid);
            if (addedOrder.indexOf(pid) === -1) {
              addedOrder.push(pid);
            }
            showBadge(pid);
          }
        });
      }
    })
    .catch(function() {});
  }

  /* Expose for infinite scroll + lightbox */
  window.refreshBadges = fetchCartAndUpdate;
  window.updateSecureBar = updateBar;
  window.pulseSecureBtn = pulseBtn;

})();
